import { useContext } from "react";
import State from "../../../../../../context";
import ModalEnableInvestments from "../../../super_admin/component/ModalEnableInvestments";
import PageProductsPrimary from "../../../super_admin/page/PageProductsPrimary";
import { updateEnabledInvestmentsForAdvisor } from "../../request";

const PageProducts = () => {
  const [state] = useContext(State);

  const submitEnableInvestments = values => {
    if (!values) return;

    state.setKeyValue("loading", true);

    updateEnabledInvestmentsForAdvisor({
      requestPayload: values,
      userEmail: state._id,
    })
      .then(advisorProducts => {
        state.setKeyValue("openModalEnableInvestments", false);
        state.setKeyValue("advisorProducts", advisorProducts);
        state.showSuccess("Investments updated");
      })
      .catch(error => state.showError(error))
      .finally(() => state.setKeyValue("loading", false));
  };

  return (
    <>
      <PageProductsPrimary showEditInvestments />

      <ModalEnableInvestments
        products={state.advisorProducts}
        loading={state.loading}
        onCancel={() => state.setKeyValue("openModalEnableInvestments", false)}
        onSuccess={submitEnableInvestments}
        open={state.openModalEnableInvestments}
        productsList={state.productsList}
      />
    </>
  );
};

export default PageProducts;
